// extracted by mini-css-extract-plugin
export default {"section":"So-z","inSectionButton":"To-z","addressCard":"Uo-z","disabled":"Vo-z","cautionBox":"Wo-z","failureBox":"Xo-z","fade-out":"Yo-z","successBox":"Zo-z"};